import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pantry-virtual-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryVirtualListLineView = _resolveComponent("PantryVirtualListLineView")
  const _component_PantryVirtualEmptyView = _resolveComponent("PantryVirtualEmptyView")
  const _component_PantryPullToRefresh = _resolveComponent("PantryPullToRefresh")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_PantryPullToRefresh, {
      topMargin: 4.4,
      enabled: _ctx.isRefreshEnabled,
      topClass: 'pantry-virtual-view-scroll',
      onRefresh: _ctx.refresh
    }, {
      default: _withCtx(() => [
        _createVNode("div", {
          class: "pantry-virtual-view-scroll",
          onScrollPassive: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onScroll($event)))
        }, [
          _withDirectives(_createVNode("div", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getVirticalLineList(), (item) => {
              return (_openBlock(), _createBlock(_component_PantryVirtualListLineView, {
                key: item.id,
                linePosition: item.id,
                list: item,
                selectMode: _ctx.selectMode,
                onSelectCheck: _ctx.onSelectCheck
              }, null, 8, ["linePosition", "list", "selectMode", "onSelectCheck"]))
            }), 128 /* KEYED_FRAGMENT */)),
            _withDirectives(_createVNode("div", { style: _ctx.styleSearchModeView }, null, 4), [
              [_vShow, _ctx.searchMode]
            ])
          ], 512), [
            [_vShow, _ctx.isShow]
          ]),
          _withDirectives(_createVNode(_component_PantryVirtualEmptyView, null, null, 512), [
            [_vShow, !_ctx.isShow]
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["topMargin", "enabled", "onRefresh"])
  ]))
}